"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GridContainerBase = exports.GridBase = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _context = require("../../context");
var _constants = require("./constants");
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0, _defineProperty2.default)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
var commonStyle = {
  flexBasis: 'auto',
  flexGrow: 0,
  display: 'flex',
  flexFlow: 'wrap',
  boxSizing: 'border-box'
};
var GridContainerBase = (0, _context.styledWithTheme)('div')(function (_ref) {
  var isNested = _ref.isNested;
  return _objectSpread(_objectSpread(_objectSpread({}, commonStyle), {}, {
    width: "calc(100% + var(".concat(_constants.GRID_SPACING_CSS_VARIABLE_NAME, "))"),
    marginLeft: "calc(var(".concat(_constants.GRID_SPACING_CSS_VARIABLE_NAME, ") * -1)"),
    marginTop: "calc(var(".concat(_constants.GRID_SPACING_CSS_VARIABLE_NAME, ") * -1)")
  }, isNested && {
    paddingLeft: "var(".concat(_constants.GRID_SPACING_CSS_VARIABLE_NAME, ")"),
    paddingTop: "var(".concat(_constants.GRID_SPACING_CSS_VARIABLE_NAME, ")")
  }), {}, (0, _defineProperty2.default)({}, ".".concat(_constants.GRID_ITEM_CLASS_NAME), {
    paddingLeft: "var(".concat(_constants.GRID_SPACING_CSS_VARIABLE_NAME, ")"),
    paddingTop: "var(".concat(_constants.GRID_SPACING_CSS_VARIABLE_NAME, ")")
  }));
});
exports.GridContainerBase = GridContainerBase;
var GridBase = (0, _context.styledWithTheme)('div')(function (_ref2) {
  var mediaQueries = _ref2.theme.mediaQueries,
    lg = _ref2.lg,
    md = _ref2.md,
    sm = _ref2.sm;
  return _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, commonStyle), mediaQueries.xl({
    width: "calc(100% * ".concat(lg, " / ").concat(_constants.GRID_COLUMNS.lg, ")")
  })), mediaQueries.lg({
    width: "calc(100% * ".concat(lg, " / ").concat(_constants.GRID_COLUMNS.lg, ")")
  })), mediaQueries.md({
    width: "calc(100% * ".concat(md, " / ").concat(_constants.GRID_COLUMNS.md, ")")
  })), mediaQueries.sm({
    width: "calc(100% * ".concat(sm, " / ").concat(_constants.GRID_COLUMNS.sm, ")")
  }));
});
exports.GridBase = GridBase;